import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@app/material/material.module';

import { TabSetComponent } from './tab-set.component';
import { TabComponent } from './tab/tab.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  declarations: [TabSetComponent, TabComponent],
  exports: [TabSetComponent, TabComponent]
})
export class TabSetModule { }
